
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/azurite",
      function () {
        return require("private-next-pages/azurite/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/azurite"])
      });
    }
  